import { Enums } from "../../../thor.enums";
import { onlineT } from "../../../typings/online";

export class LinkPaymentDialogItemsController {
    public static $inject: string[] = ["localeNumber", "utilsService"];

    // binded
    public items: onlineT.Item[];
    public saleCurrency: Enums.Currency;

    constructor(private localeNumber, public utilsService) {}

    public calculateFinalSoldPriceTotalWithoutDeposit(): string {
        let finalSoldPriceTotal: number;
        finalSoldPriceTotal = this.localeNumber.sumNbrs(this.items.map(item => item.finalSoldPrice));
        finalSoldPriceTotal = this.localeNumber.roundNbr(finalSoldPriceTotal);
        return this.localeNumber.formatCurrency(finalSoldPriceTotal);
    }
}
